import React from "react";
import i18n from "../utils/i18n/i18n";
import { STRING_LANGUAGE_COMPRARTODO } from "../utils/const/string-const";
import { EC } from "../utils/const/ecommerce-colors-const";
import { APP_LANGUAGES } from "../utils/i18n/app-languages";

export default function LanguageDropdown({
    languages = APP_LANGUAGES,
    selectedLanguage,
    setSelectedLanguage,
    isOpen,
    setIsOpen,
    showLabel = true,
}) {
    const current = languages.find((l) => l.value === selectedLanguage);

    return (
        <div className="relative language-dropdown">
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition border border-transparent ${EC.nav.langHover}`}
                aria-expanded={isOpen}
                aria-label="Language"
            >
                <span className="text-xl">{current?.flag}</span>
                {showLabel && (
                    <span className="text-slate-700 text-sm font-medium hidden md:inline">
                        {current?.label}
                    </span>
                )}
                <svg
                    className={`w-4 h-4 text-slate-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-slate-200 py-2 z-50">
                    {languages.map((language) => (
                        <button
                            type="button"
                            key={language.value}
                            onClick={() => {
                                if (language.value === selectedLanguage) {
                                    setIsOpen(false);
                                    return;
                                }
                                setSelectedLanguage(language.value);
                                setIsOpen(false);
                                i18n.changeLanguage(language.value);
                                localStorage.setItem(STRING_LANGUAGE_COMPRARTODO, language.value);
                            }}
                            className={`w-full flex items-center space-x-3 px-4 py-2 transition text-left hover:bg-ct-primary-50 ${
                                selectedLanguage === language.value ? EC.nav.langActive : "text-slate-700"
                            }`}
                        >
                            <span className="text-xl">{language.flag}</span>
                            <span className="font-medium">{language.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
